var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "254px",
    viewBox: "0 0 360 254",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empty-state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C3.342,0 3.496,1.1018 4.246,1.8518 C4.996,2.6018 6,2.6592 6,3 C6,3.3408 4.989,3.4936 4.239,4.2436 C3.489,4.9936 3.434,6 3,6 C2.566,6 2.488,4.9428 1.738,4.1928 C0.988,3.4428 0,3.3736 0,3 C0,2.6264 0.905,2.615 1.689,1.8307 C2.473,1.0463 2.658,0 3,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C5.571,0 5.827,1.83642 7.077,3.08642 C8.327,4.33642 10,4.43202 10,5 C10,5.56798 8.316,5.8226 7.066,7.0726 C5.816,8.3226 5.723,10 5,10 C4.277,10 4.146,8.23797 2.896,6.98797 C1.646,5.73797 0,5.62266 0,5 C0,4.37734 1.508,4.35838 2.815,3.0511 C4.122,1.74383 4.429,0 5,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C3.342,0 3.496,1.1018 4.246,1.8518 C4.996,2.6018 6,2.6592 6,3 C6,3.3408 4.989,3.4936 4.239,4.2436 C3.489,4.9936 3.434,6 3,6 C2.566,6 2.488,4.9428 1.738,4.1928 C0.988,3.4428 0,3.3736 0,3 C0,2.6264 0.905,2.615 1.689,1.8307 C2.473,1.0463 2.658,0 3,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C3.342,0 3.496,1.1018 4.246,1.8518 C4.996,2.6018 6,2.6592 6,3 C6,3.3408 4.989,3.4936 4.239,4.2436 C3.489,4.9936 3.434,6 3,6 C2.566,6 2.488,4.9428 1.738,4.1928 C0.988,3.4428 0,3.3736 0,3 C0,2.6264 0.905,2.615 1.689,1.8307 C2.473,1.0463 2.658,0 3,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C3.342,0 3.496,1.1018 4.246,1.8518 C4.996,2.6018 6,2.6592 6,3 C6,3.3408 4.989,3.4936 4.239,4.2436 C3.489,4.9936 3.434,6 3,6 C2.566,6 2.488,4.9428 1.738,4.1928 C0.988,3.4428 0,3.3736 0,3 C0,2.6264 0.905,2.615 1.689,1.8307 C2.473,1.0463 2.658,0 3,0 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.105,4 4,3.1046 4,2 C4,0.8954 3.105,0 2,0 C0.895,0 0,0.8954 0,2 C0,3.1046 0.895,4 2,4 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,3 C2.328,3 3,2.328 3,1.5 C3,0.672 2.328,0 1.5,0 C0.672,0 0,0.672 0,1.5 C0,2.328 0.672,3 1.5,3 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,3 C2.328,3 3,2.328 3,1.5 C3,0.672 2.328,0 1.5,0 C0.672,0 0,0.672 0,1.5 C0,2.328 0.672,3 1.5,3 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2 C1.552,2 2,1.5523 2,1 C2,0.4477 1.552,0 1,0 C0.448,0 0,0.4477 0,1 C0,1.5523 0.448,2 1,2 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2 C1.5523,2 2,1.552 2,1 C2,0.448 1.5523,0 1,0 C0.4477,0 0,0.448 0,1 C0,1.552 0.4477,2 1,2 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C3.342,0 3.496,1.1018 4.246,1.8518 C4.996,2.6018 6,2.6592 6,3 C6,3.3408 4.989,3.4936 4.239,4.2436 C3.489,4.9936 3.434,6 3,6 C2.566,6 2.488,4.9428 1.738,4.1928 C0.988,3.4428 0,3.3736 0,3 C0,2.6264 0.905,2.615 1.689,1.8307 C2.473,1.0463 2.658,0 3,0 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2458,11.0027 C31.8404,9.5167 32.6329,8.1314 33.5906,6.8791 C36.788,2.6979 41.8282,0 47.5,0 C55.9672,0 63.0285,6.0125 64.65,14.0012 C69.319,14.0734 73.17,17.514 73.882,22 L95,22 C95.552,22 96,22.448 96,23 C96,23.552 95.552,24 95,24 L72.985,24 C72.456,24 72.018,23.587 71.987,23.058 C71.759,19.122 68.494,16 64.5,16 C64.29,16 64.101,16.007 63.8953,16.024 C63.3717,16.066 62.9051,15.695 62.827,15.176 L62.8232,15.15 C61.7223,7.9075 55.6066,2.3113 48.1295,2.0125 C47.9207,2.0042 47.7108,2 47.5,2 C42.4295,2 37.9262,4.4351 35.098,8.2008 C33.1526,10.7912 32,14.011 32,17.5 C32,18.052 31.5523,18.5 31,18.5 C30.4477,18.5 30,18.052 30,17.5 C30,15.947 30.2022,14.4419 30.5817,13.0086 C25.2529,13.2278 21,17.617 21,23 C21,23.552 20.5523,24 20,24 L1,24 C0.4477,24 0,23.552 0,23 C0,22.448 0.4477,22 1,22 L19.0411,22 C19.5492,15.84 24.7093,11 31,11 C31.0811,11.0001 31.1633,11.001 31.2458,11.0027 Z M99,23 C99,22.448 99.448,22 100,22 L109,22 C109.552,22 110,22.448 110,23 C110,23.552 109.552,24 109,24 L100,24 C99.448,24 99,23.552 99,23 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,0 C51.433,0 43.891,6.5214 42.306,15.1297 C37.689,15.8434 34.022,19.4262 33.181,24 L13,24 C12.448,24 12,24.4477 12,25 C12,25.5523 12.448,26 13,26 L34.049,26 C34.563,26 34.994,25.6103 35.045,25.0988 C35.472,20.7968 38.931,17.3846 43.254,17.0304 C43.72,16.9922 44.097,16.6363 44.163,16.1734 C45.293,8.1627 52.177,2 60.5,2 C66.644,2 72.006,5.3584 74.846,10.3432 C73.693,10.5909 72.585,10.9655 71.571,11.444 C71.072,11.681 70.86,12.2775 71.097,12.7764 C71.334,13.2752 71.93,13.4875 72.429,13.2505 C73.673,12.6553 74.967,12.2639 76.356,12.095 C76.396,12.0952 76.436,12.093 76.477,12.0882 C76.986,12.0284 77.475,11.9996 78,12 C81.687,12 85.015,13.5347 87.381,16 C89.622,18.3358 91,21.507 91,25 C91,25.4833 91.343,25.8864 91.799,25.9797 C91.864,25.993 91.931,26 92,26 L112,26 C112.552,26 113,25.5523 113,25 C113,24.4477 112.552,24 112,24 L92.967,24 C92.742,20.5796 91.37,17.4724 89.233,15.059 C86.485,11.956 82.471,10 78,10 C77.655,10.0003 77.302,10.0128 76.955,10.0366 C73.884,4.0779 67.669,0 60.5,0 Z M115,25 C115,24.4477 115.448,24 116,24 L120,24 C120.552,24 121,24.4477 121,25 C121,25.5523 120.552,26 120,26 L116,26 C115.448,26 115,25.5523 115,25 Z M0,25 C0,24.4477 0.448,24 1,24 L9,24 C9.552,24 10,24.4477 10,25 C10,25.5523 9.552,26 9,26 L1,26 C0.448,26 0,25.5523 0,25 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.108,26.09 C40.325,12.584 51.677,2 65.5,2 C76.138,2 85.313,8.268 89.532,17.316 C88.061,18.07 86.767,19.118 85.728,20.382 C85.377,20.809 85.438,21.439 85.865,21.79 C86.291,22.14 86.922,22.079 87.272,21.653 C89.108,19.421 91.888,18 95,18 C99.901,18 103.98,21.527 104.835,26.181 C104.92,26.642 105.313,26.981 105.779,26.999 L105.791,27 C105.8,27 105.809,27 105.819,27 L105.836,27 L141,27 C141.552,27 142,26.552 142,26 C142,25.448 141.552,25 141,25 L106.622,25 C105.289,19.824 100.592,16 95,16 C93.74,16 92.524,16.194 91.383,16.555 C86.866,6.783 76.976,0 65.5,0 C50.945,0 38.939,10.91 37.213,25 L11,25 C10.448,25 10,25.448 10,26 C10,26.552 10.448,27 11,27 L38.112,27 C38.63,27 39.062,26.605 39.108,26.09 Z M0,26 C0,25.448 0.448,25 1,25 L7,25 C7.552,25 8,25.448 8,26 C8,26.552 7.552,27 7,27 L1,27 C0.448,27 0,26.552 0,26 Z",
    id: "path-27"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-state"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 360,
    height: 254
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,20 C183.342,20 183.496,21.1018 184.246,21.8518 C184.996,22.6018 186,22.6592 186,23 C186,23.3408 184.989,23.4936 184.239,24.2436 C183.489,24.9936 183.434,26 183,26 C182.566,26 182.488,24.9428 181.738,24.1928 C180.988,23.4428 180,23.3736 180,23 C180,22.6264 180.905,22.615 181.689,21.8307 C182.473,21.0463 182.658,20 183,20 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(180.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114,0 C114.571,0 114.827,1.83642 116.077,3.08642 C117.327,4.33642 119,4.43202 119,5 C119,5.56798 117.316,5.8226 116.066,7.0726 C114.816,8.3226 114.723,10 114,10 C113.277,10 113.146,8.23797 111.896,6.98797 C110.646,5.73797 109,5.62266 109,5 C109,4.37734 110.508,4.35838 111.815,3.0511 C113.122,1.74383 113.429,0 114,0 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(109.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,62 C105.342,62 105.496,63.1018 106.246,63.8518 C106.996,64.6018 108,64.6592 108,65 C108,65.3408 106.989,65.4936 106.239,66.2436 C105.489,66.9936 105.434,68 105,68 C104.566,68 104.488,66.9428 103.738,66.1928 C102.988,65.4428 102,65.3736 102,65 C102,64.6264 102.905,64.615 103.689,63.8307 C104.473,63.0463 104.658,62 105,62 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(102.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141,27 C141.342,27 141.496,28.1018 142.246,28.8518 C142.996,29.6018 144,29.6592 144,30 C144,30.3408 142.989,30.4936 142.239,31.2436 C141.489,31.9936 141.434,33 141,33 C140.566,33 140.488,31.9428 139.738,31.1928 C138.988,30.4428 138,30.3736 138,30 C138,29.6264 138.905,29.615 139.689,28.8307 C140.473,28.0463 140.658,27 141,27 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(138.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220,54 C220.342,54 220.496,55.1018 221.246,55.8518 C221.996,56.6018 223,56.6592 223,57 C223,57.3408 221.989,57.4936 221.239,58.2436 C220.489,58.9936 220.434,60 220,60 C219.566,60 219.488,58.9428 218.738,58.1928 C217.988,57.4428 217,57.3736 217,57 C217,56.6264 217.905,56.615 218.689,55.8307 C219.473,55.0463 219.658,54 220,54 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(217.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211,33 C212.105,33 213,32.1046 213,31 C213,29.8954 212.105,29 211,29 C209.895,29 209,29.8954 209,31 C209,32.1046 209.895,33 211,33 Z",
    id: "Shape",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(209.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,128 C251.328,128 252,127.328 252,126.5 C252,125.672 251.328,125 250.5,125 C249.672,125 249,125.672 249,126.5 C249,127.328 249.672,128 250.5,128 Z",
    id: "Shape",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(249.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.5,151 C224.328,151 225,150.328 225,149.5 C225,148.672 224.328,148 223.5,148 C222.672,148 222,148.672 222,149.5 C222,150.328 222.672,151 223.5,151 Z",
    id: "Shape",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(222.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103,29 C103.552,29 104,28.5523 104,28 C104,27.4477 103.552,27 103,27 C102.448,27 102,27.4477 102,28 C102,28.5523 102.448,29 103,29 Z",
    id: "Shape",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(102.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99,131 C99.5523,131 100,130.552 100,130 C100,129.448 99.5523,129 99,129 C98.4477,129 98,129.448 98,130 C98,130.552 98.4477,131 99,131 Z",
    id: "Shape",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(98.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251,33 C251.342,33 251.496,34.1018 252.246,34.8518 C252.996,35.6018 254,35.6592 254,36 C254,36.3408 252.989,36.4936 252.239,37.2436 C251.489,37.9936 251.434,39 251,39 C250.566,39 250.488,37.9428 249.738,37.1928 C248.988,36.4428 248,36.3736 248,36 C248,35.6264 248.905,35.615 249.689,34.8307 C250.473,34.0463 250.658,33 251,33 Z",
    id: "Shape",
    fill: "#FFDB63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(248.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102,101 C94.5517,84.9237 86,84 78,87.5 C87,88.6012 94,96 97,103 C97.5,102 100.5,100.5 102,101 Z",
    id: "Shape",
    fillOpacity: 0.04,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2458,96.0027 C67.8404,94.5167 68.6329,93.1314 69.5906,91.8791 C72.788,87.6979 77.8282,85 83.5,85 C91.9672,85 99.0285,91.0125 100.65,99.0012 C105.319,99.0734 109.17,102.514 109.882,107 L131,107 C131.552,107 132,107.448 132,108 C132,108.552 131.552,109 131,109 L108.985,109 C108.456,109 108.018,108.587 107.987,108.058 C107.759,104.122 104.494,101 100.5,101 C100.29,101 100.101,101.007 99.8953,101.024 C99.3717,101.066 98.9051,100.695 98.827,100.176 L98.8232,100.15 C97.7223,92.9075 91.6066,87.3113 84.1295,87.0125 C83.9207,87.0042 83.7108,87 83.5,87 C78.4295,87 73.9262,89.4351 71.098,93.2008 C69.1526,95.7912 68,99.011 68,102.5 C68,103.052 67.5523,103.5 67,103.5 C66.4477,103.5 66,103.052 66,102.5 C66,100.947 66.2022,99.4419 66.5817,98.0086 C61.2529,98.2278 57,102.617 57,108 C57,108.552 56.5523,109 56,109 L37,109 C36.4477,109 36,108.552 36,108 C36,107.448 36.4477,107 37,107 L55.0411,107 C55.5492,100.84 60.7093,96 67,96 C67.0811,96.0001 67.1633,96.001 67.2458,96.0027 Z M135,108 C135,107.448 135.448,107 136,107 L145,107 C145.552,107 146,107.448 146,108 C146,108.552 145.552,109 145,109 L136,109 C135.448,109 135,108.552 135,108 Z",
    id: "Shape",
    fill: "#CAD3D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279,74 C276,64.5 265,61.1673 257,64.6673 C266,65.7685 270,70 273,77 C274.5,75.5 276.5,74.5 279,74 Z",
    id: "Shape",
    fillOpacity: 0.04,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5,62 C254.433,62 246.891,68.5214 245.306,77.1297 C240.689,77.8434 237.022,81.4262 236.181,86 L216,86 C215.448,86 215,86.4477 215,87 C215,87.5523 215.448,88 216,88 L237.049,88 C237.563,88 237.994,87.6103 238.045,87.0988 C238.472,82.7968 241.931,79.3846 246.254,79.0304 C246.72,78.9922 247.097,78.6363 247.163,78.1734 C248.293,70.1627 255.177,64 263.5,64 C269.644,64 275.006,67.3584 277.846,72.3432 C276.693,72.5909 275.585,72.9655 274.571,73.444 C274.072,73.681 273.86,74.2775 274.097,74.7764 C274.334,75.2752 274.93,75.4875 275.429,75.2505 C276.673,74.6553 277.967,74.2639 279.356,74.095 C279.396,74.0952 279.436,74.093 279.477,74.0882 C279.986,74.0284 280.475,73.9996 281,74 C284.687,74 288.015,75.5347 290.381,78 C292.622,80.3358 294,83.507 294,87 C294,87.4833 294.343,87.8864 294.799,87.9797 C294.864,87.993 294.931,88 295,88 L315,88 C315.552,88 316,87.5523 316,87 C316,86.4477 315.552,86 315,86 L295.967,86 C295.742,82.5796 294.37,79.4724 292.233,77.059 C289.485,73.956 285.471,72 281,72 C280.655,72.0003 280.302,72.0128 279.955,72.0366 C276.884,66.0779 270.669,62 263.5,62 Z M318,87 C318,86.4477 318.448,86 319,86 L323,86 C323.552,86 324,86.4477 324,87 C324,87.5523 323.552,88 323,88 L319,88 C318.448,88 318,87.5523 318,87 Z M203,87 C203,86.4477 203.448,86 204,86 L212,86 C212.552,86 213,86.4477 213,87 C213,87.5523 212.552,88 212,88 L204,88 C203.448,88 203,87.5523 203,87 Z",
    id: "Shape",
    fill: "#CAD3D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(203.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197,173 C186.5,156.5 171.5,153 158.5,158 C176.5,159.5 188.448,172.971 190,179 C193.5,175 196,173 197,173 Z",
    id: "Shape",
    fillOpacity: 0.04,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.108,181.09 C145.325,167.584 156.677,157 170.5,157 C181.138,157 190.313,163.268 194.532,172.316 C193.061,173.07 191.767,174.118 190.728,175.382 C190.377,175.809 190.438,176.439 190.865,176.79 C191.291,177.14 191.922,177.079 192.272,176.653 C194.108,174.421 196.888,173 200,173 C204.901,173 208.98,176.527 209.835,181.181 C209.92,181.642 210.313,181.981 210.779,181.999 L210.791,182 C210.8,182 210.809,182 210.819,182 L210.836,182 L246,182 C246.552,182 247,181.552 247,181 C247,180.448 246.552,180 246,180 L211.622,180 C210.289,174.824 205.592,171 200,171 C198.74,171 197.524,171.194 196.383,171.555 C191.866,161.783 181.976,155 170.5,155 C155.945,155 143.939,165.91 142.213,180 L116,180 C115.448,180 115,180.448 115,181 C115,181.552 115.448,182 116,182 L143.112,182 C143.63,182 144.062,181.605 144.108,181.09 Z M105,181 C105,180.448 105.448,180 106,180 L112,180 C112.552,180 113,180.448 113,181 C113,181.552 112.552,182 112,182 L106,182 C105.448,182 105,181.552 105,181 Z",
    id: "Shape",
    fill: "#CAD3D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(105.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.405,43.809 C168.142,42.653 166.5,42 164.753,42 C160.97,42 157.907,45.025 157.907,48.75 C157.907,51.4106 159.487,53.788 161.906,54.8819 C162.42,55.1145 162.64,55.7264 162.392,56.2332 C161.775,57.4903 161.451,58.8503 161.451,60.25 C161.451,65.3558 165.646,69.5 170.827,69.5 C173.416,69.5 175.833,68.4561 177.594,66.6415 C177.783,66.4475 178.041,66.338 178.312,66.338 L190.923,66.338 L169.405,43.809 Z M145,79 C136.163,79 129,86.1634 129,95 L129,125 L147,125 L161,125 L223,125 L223,96 C223,86.4891 215.439,79 206,79 L203,79 C202.981,79 202.959,79.0002 202.933,79.0006 C202.895,79.0012 202.85,79.0021 202.801,79.0031 C202.578,79.0076 202.258,79.0141 202,79 L147,79 L147,79.1238 C146.345,79.0421 145.677,79 145,79 Z M173,155.108 L173,127 L179,127 L179,156.289 C177.079,155.69 175.071,155.288 173,155.108 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,125 L223,125 L223,96 C223,86.4891 215.561,79 206,79 L204,79 C203.437,79 202.89,79.0165 202.357,79.0489 C210.207,80.2142 217,87.2985 217,96 L217,125 Z M180,89 C180,91.7614 177.761,94 175,94 C172.239,94 170,91.7614 170,89 C170,86.2386 172.239,84 175,84 C177.761,84 180,86.2386 180,89 Z",
    id: "Shape",
    fill: "#A6D2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,51.2326 C156.897,53.3238 158.299,55.1168 160.204,56.247 C159.709,57.5197 159.451,58.8688 159.451,60.25 C159.451,64.6591 162.015,68.4737 165.747,70.3187 L165.747,77 L145,77 C135.059,77 127,85.0589 127,95 L127,127 L145,127 L163,127 L171,127 L171,155.004 C171.673,155.016 172.34,155.051 173,155.108 L173,127 L179,127 L179,156.289 C179.678,156.501 180.345,156.737 181,156.997 L181,127 L225,127 L225,96 C225,85.3802 216.539,77 206,77 L171.747,77 L171.747,71.4635 C174.387,71.253 176.837,70.1416 178.724,68.338 L193.261,68.338 C194.141,68.338 194.592,67.2835 193.984,66.6472 L170.803,42.3807 C169.128,40.8439 167.006,40 164.753,40 C160.712,40 157.301,42.6819 156.245,46.3477 L154.948,46.889 L152.615,47.8618 C151.795,48.2038 151.795,49.3658 152.615,49.7078 L154.949,50.6808 L156.27,51.2326 Z M167.747,77 L167.747,71.0827 C168.392,71.2618 169.061,71.386 169.747,71.4499 L169.747,77 L167.747,77 Z M223,125 L223,96 C223,86.4891 215.439,79 206,79 L203,79 C202.952,79 202.883,79.0014 202.801,79.0031 C202.578,79.0076 202.258,79.0141 202,79 L153.254,79 C159.043,81.9925 163,88.0341 163,95 L163,125 L171,125 L181,125 L223,125 Z M129,95 C129,86.1634 136.163,79 145,79 C153.837,79 161,86.1634 161,95 L161,125 L129,125 L129,95 Z M189,90 L175,90 C174.436,90 174,89.5523 174,89 C174,88.4477 174.436,88 175,88 L189,88 L208,88 L208,119 L199,111 L189,119 L189,90 Z M206,90 L191,90 L191,115 L199,108.5 L206,115 L206,90 Z M169.405,43.809 C168.142,42.653 166.5,42 164.753,42 C160.97,42 157.907,45.0251 157.907,48.75 C157.907,51.4106 159.487,53.788 161.906,54.8819 C162.42,55.1145 162.64,55.7264 162.392,56.2332 C161.775,57.4903 161.451,58.8503 161.451,60.25 C161.451,65.3558 165.646,69.5 170.827,69.5 C173.416,69.5 175.833,68.4561 177.594,66.6415 C177.783,66.4475 178.041,66.338 178.312,66.338 L190.923,66.338 L169.405,43.809 Z M166.6,55.5192 C166.049,55.5499 165.627,56.0219 165.657,56.5733 C165.716,57.6331 166.216,59.1231 167.529,60.5908 C169.182,62.4381 171.756,63.7011 175.382,64.1506 C175.93,64.2186 176.429,63.8293 176.497,63.2812 C176.565,62.7331 176.176,62.2337 175.628,62.1658 C172.465,61.7737 170.337,60.7295 169.02,59.2572 C168.448,58.618 168.068,57.9387 167.842,57.2642 C167.712,56.8756 167.662,56.5903 167.654,56.4621 C167.624,55.9107 167.152,55.4885 166.6,55.5192 Z M163.247,49.838 C164.075,49.838 164.747,49.1664 164.747,48.338 C164.747,47.5096 164.075,46.838 163.247,46.838 C162.418,46.838 161.747,47.5096 161.747,48.338 C161.747,49.1664 162.418,49.838 163.247,49.838 Z",
    id: "Shape",
    fill: "#0B77E3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u0416\\u0434\\u0438\\u0442\\u0435-\\u043F\\u043E\\u044F\\u0432\\u043B\\u0435\\u043D\\u0438\\u044F-\\u043C\\u0430\\u0442\\u0435",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 17,
    fontWeight: "bold",
    letterSpacing: 0.327857167,
    fill: "#363636"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47,
    y: 221
  }, "\u0416\u0434\u0438\u0442\u0435 \u043F\u043E\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.c04ea4ea1fdfcfe108b7a0e0908d55d4.svg";
export { ForwardRef as ReactComponent };